import { Modal } from '../Modal/Modal';
import * as S from '../Modal/Styles';
import { useState, useEffect, useContext } from 'react';
import { useTour } from '@reactour/tour';
import modalImage from '../../assets/modal-image.png';
import TutorialIconOne from '../../assets/tutorial-icon-1.png';
import TutorialIconTwo from '../../assets/tutorial-icon-2.png';
import TutorialIconThree from '../../assets/tutorial-icon-3.png';
import CloseIcon from '../../assets/icons/close_icon.svg';
import { TutorialContext, TutorialEnum } from '../../handlers/TutorialHandler';
import {
  tutorialOneSteps,
  tutorialTwoSteps,
  tutorialThreeSteps
} from './tutorials';
import { TilesContext } from '../../handlers/TilesHandler';
import { TranslationContext } from '../../handlers/TranslationsHandler';

export const TutorialModal = () => {
  const [hideModal, setHideModal] = useState(false);
  const { isOpen, setIsOpen, setSteps } = useTour();
  const { setCurrentStep } = useTour();
  const { setTutorialType, isModalClosed, setCloseModal } = useContext(
    TutorialContext
  );
  const { isInSpecialMode } = useContext(TilesContext);

  const { translate } = useContext(TranslationContext);

  const saveHideModalHandler = event => {
    event.preventDefault();
    setCloseModal(true);
    localStorage.setItem('tutorialMode', JSON.stringify(!hideModal));
  };

  useEffect(() => {
    const isInTutorialMode: string | null = localStorage.getItem(
      'tutorialMode'
    );

    if (!isOpen) {
      if (!isInTutorialMode || JSON.parse(isInTutorialMode) === true) {
        setCloseModal(false);
      } else {
        setCloseModal(true);
      }
    } else {
      setCloseModal(true);
    }
  }, [isOpen]);

  const handleTutorial = (tutorialSteps, tutorialEnum) => {
    setSteps?.(tutorialSteps);
    setCurrentStep(0);
    setCloseModal(true);
    setIsOpen(true);
    setTutorialType(tutorialEnum);
  };

  return (
    <Modal isOpen={!isModalClosed}>
      <S.ModalHeader>
        {isInSpecialMode ? (
          <div>
            {translate('welcomeToTheConfiguratorFor')} <span>[ui!]</span> EASY
          </div>
        ) : (
          <div>
            {translate('welcomeTo')} <span>[ui!]</span>{' '}
            {translate('cockpitConfigurator')}
          </div>
        )}
        <img src={CloseIcon} onClick={() => setCloseModal(true)} alt="close" />
      </S.ModalHeader>
      <S.ModalMain>
        <S.ModalText>{translate('tutorialIntro')}</S.ModalText>
        <S.ModalMainContainer>
          <S.ModalImage src={modalImage} />
          <S.ModalOptionContainer>
            <S.ModalOption
              onClick={() => handleTutorial(tutorialOneSteps, TutorialEnum.one)}
            >
              <S.ModalOptionButton>
                <S.OptionIcon src={TutorialIconOne} />
              </S.ModalOptionButton>
              <S.ModalTextContainer>
                <S.ModalOptionText>
                  {translate('fillTilesTutorial')}
                </S.ModalOptionText>
              </S.ModalTextContainer>
            </S.ModalOption>
            <S.ModalOption
              onClick={() => handleTutorial(tutorialTwoSteps, TutorialEnum.two)}
            >
              <S.ModalOptionButton>
                <S.OptionIcon src={TutorialIconTwo} />
              </S.ModalOptionButton>
              <S.ModalTextContainer>
                <S.ModalOptionText>
                  {translate('changeAppearanceTutorial')}
                </S.ModalOptionText>
              </S.ModalTextContainer>
            </S.ModalOption>
            <S.ModalOption
              onClick={() =>
                handleTutorial(tutorialThreeSteps, TutorialEnum.three)
              }
            >
              <S.ModalOptionButton>
                <S.OptionIcon src={TutorialIconThree} />
              </S.ModalOptionButton>
              <S.ModalTextContainer>
                <S.ModalOptionText>
                  {translate('saveConfigTutorial')}
                </S.ModalOptionText>
              </S.ModalTextContainer>
            </S.ModalOption>
          </S.ModalOptionContainer>
        </S.ModalMainContainer>
      </S.ModalMain>
      <S.ModalFooter onSubmit={saveHideModalHandler}>
        <S.CheckboxContainer>
          <input
            type="checkbox"
            name="exit"
            id="exit"
            checked={hideModal}
            onChange={() => setHideModal(!hideModal)}
          />
          <label htmlFor="exit">{translate('doNotShowAgain')}</label>
        </S.CheckboxContainer>
        <S.ModalCloseButton>{translate('close')}</S.ModalCloseButton>
      </S.ModalFooter>
    </Modal>
  );
};
